<template>
  <div class="container">
    <div class="img">
      <img src="@/assets/pc/images/404.gif" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFind"
};
</script>

<style lang="stylus" scoped>
.container
  margin-top 100px
  .img
    width 500px
    margin 0 auto
    img
      width 100%
</style>
